// extracted by mini-css-extract-plugin
module.exports = {"htmlArea":"HtmlAreaPart_htmlArea__omPG_"};